export const MIN_TOP_OFFENDER_TRACE_COUNT = 10;

export const formatCurrency = (value, digits = 2) => {
  if (value == null || Number.isNaN(value)) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
};

export const formatCompactCurrency = (value) => {
  if (value == null || Number.isNaN(value)) return '-';
  const absoluteValue = Math.abs(value);

  if (absoluteValue >= 1000) return `$${(value / 1000).toFixed(1)}K`;
  if (absoluteValue >= 1) return `$${value.toFixed(2)}`;
  if (absoluteValue >= 0.01) return `$${value.toFixed(4)}`;
  if (absoluteValue >= 0.000001) return `$${value.toFixed(6)}`;
  if (absoluteValue >= 0.00000001) return `$${value.toFixed(8)}`;
  if (absoluteValue > 0) return '<$0.00000001';
  return '$0.000000';
};

export const formatInteger = (value) => {
  if (value == null || Number.isNaN(value)) return '-';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
};

export const formatPercent = (value, digits = 0) => {
  if (value == null || Number.isNaN(value)) return '-';
  return `${value.toFixed(digits)}%`;
};
